import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {KTSVG} from '../../../helpers'
import {useLayout} from '../../core'
import {getLogoUrl} from '../../../../app/constructor/helpers/dynamicStyles'
import {useThemeMode} from '../../../partials'
import {useAuth} from '../../../../app/modules/auth'
import {useEffect, useState} from 'react'
import {getApiUrl} from '../../../../app/api'

const SidebarLogo = () => {
    const {config} = useLayout()
    const {mode} = useThemeMode()
    const {currentUser} = useAuth() as any

    const [apiBaseUrl, setApiBaseUrl] = useState(window.location.origin)
    useEffect(() => {
        getApiUrl().then(url => {
            setApiBaseUrl(url)
        })
    }, [])
    const logoSrc = currentUser?.company_logo_url
        ? currentUser.company_logo_url.startsWith('http')
            ? currentUser.company_logo_url
            : `${apiBaseUrl}${currentUser.company_logo_url}`
        : getLogoUrl()
    const appSidebarDefaultMinimizeDesktopEnabled =
        config?.app?.sidebar?.default?.minimize?.desktop?.enabled
    const appSidebarDefaultCollapseDesktopEnabled =
        config?.app?.sidebar?.default?.collapse?.desktop?.enabled
    const toggleType = appSidebarDefaultCollapseDesktopEnabled
        ? 'collapse'
        : appSidebarDefaultMinimizeDesktopEnabled
        ? 'minimize'
        : ''
    const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
    const appSidebarDefaultMinimizeDefault =
        config.app?.sidebar?.default?.minimize?.desktop?.default

    return (
        <div className='app-sidebar-logo px-9' id='kt_app_sidebar_logo'>
            <Link to='/dashboard'>
                {config.layoutType === 'dark-sidebar' ? (
                    <img alt='Logo' src={logoSrc} className='h-35px app-sidebar-logo-default' />
                ) : (
                    <>
                        <img
                            alt='Logo'
                            src={logoSrc}
                            className='h-35px app-sidebar-logo-default theme-light-show'
                        />
                        <img
                            alt='Logo'
                            src={logoSrc}
                            className='h-35px app-sidebar-logo-default theme-dark-show'
                        />
                    </>
                )}
                {/* минимизированное лого, нужно сделать */}
                {/*  <img
          alt='Logo'
          src={toAbsoluteUrl('/media/logos/default-small.svg')}
          className='h-20px app-sidebar-logo-minimize'
        /> */}
            </Link>

            {(appSidebarDefaultMinimizeDesktopEnabled ||
                appSidebarDefaultCollapseDesktopEnabled) && (
                <div
                    id='kt_app_sidebar_toggle'
                    className={clsx(
                        'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
                        {active: appSidebarDefaultMinimizeDefault}
                    )}
                    data-kt-toggle='true'
                    data-kt-toggle-state={toggleState}
                    data-kt-toggle-target='body'
                    data-kt-toggle-name={`app-sidebar-${toggleType}`}
                >
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr079.svg'
                        className='svg-icon-2 rotate-180'
                    />
                </div>
            )}
        </div>
    )
}

export {SidebarLogo}
